import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import WizardHeader from '../../../../components/WizardHeader/WizardHeader';
import {Feedback, ProtocolEditorViewMode} from '../../../../constants/dataEnum';
import withIntl from '../../../../lib/withIntl';
import {cancelPicklist, picklistOnBack} from '../../../../stores/business/taskListPicklistBusiness';
import {hideModal, showModal} from '../../../../stores/actions/modalStateAction';
import {showSnackbar} from '../../../../stores/actions/appStateAction';
import {setAllTaskIsSelected} from '../../../../stores/actions/cardStateAction';
import {globalAddUndoItem} from '../../../../stores/business/undoRedoBusinessAction';
import {setSelectedMenu} from '../../../../stores/actions/protocolEditorAction';

const mapStateToProps = (state) => ({
  picklistDefinition: state.temporaryState?.picklistDefinition ?? {labwareMap: {}, currentStep: 0},
});

const mapDispatchToProps = (dispatch) => ({
  taskListPicklistBusinessCancelPicklist: bindActionCreators(cancelPicklist, dispatch),
  taskListPicklistBusinessPicklistOnBack: bindActionCreators(picklistOnBack, dispatch),
  modalStateActionShowModal: bindActionCreators(showModal, dispatch),
  modalStateActionHideModal: bindActionCreators(hideModal, dispatch),
  appStateActionShowSnackbar: bindActionCreators(showSnackbar, dispatch),
  cardStateActionSetAllTaskIsSelected: bindActionCreators(setAllTaskIsSelected, dispatch),
  undoRedoBusinessActionGlobalAddUndoItem: bindActionCreators(globalAddUndoItem, dispatch),
  setProtocolEditorMode: bindActionCreators(setSelectedMenu, dispatch),
});

function PicklistHeader({
  headerRef,
  picklistDefinition,
  taskListPicklistBusinessCancelPicklist,
  taskListPicklistBusinessPicklistOnBack,
  modalStateActionShowModal,
  modalStateActionHideModal,
  appStateActionShowSnackbar,
  cardStateActionSetAllTaskIsSelected,
  undoRedoBusinessActionGlobalAddUndoItem,
  setProtocolEditorMode,
  intl,
}) {
  const defaultText = intl.formatMessage({id: 'protocolEditor.picklist.header.title'});
  const totalLabware = picklistDefinition.totalDeckIdNeedToDefine ?? 0;

  const hideBackButton = () => picklistDefinition.currentStep <= 1;
  // const hideNextButton = () => picklistDefinition.currentStep >= totalLabware;

  const onCancel = () => {
    const title = intl.formatMessage({id: 'protocolEditor.picklist.cancelModal.title'});
    const text = intl.formatMessage({id: 'protocolEditor.picklist.cancelModal.text'});
    const okButtonText = intl.formatMessage({id: 'protocolEditor.picklist.cancelModal.okButton'});
    const cancelButtonText = intl.formatMessage({id: 'protocolEditor.picklist.cancelModal.cancelButton'});
    const cancelSuccessMessage = intl.formatMessage({id: 'protocolEditor.picklist.cancelModal.successMessage'});

    const modalOkHandler = () => {
      setProtocolEditorMode(ProtocolEditorViewMode.SIMPLE_TRANSFER);
      taskListPicklistBusinessCancelPicklist();
      modalStateActionHideModal();
      appStateActionShowSnackbar(Feedback.SUCCESS, cancelSuccessMessage);
      cardStateActionSetAllTaskIsSelected(false);
      undoRedoBusinessActionGlobalAddUndoItem();
    };

    const modalCancelHandler = () => {
      modalStateActionHideModal();
    };

    modalStateActionShowModal(
      title,
      text,
      [
        {className: 'btn-lg', style: 'primary', handlerClick: modalOkHandler, text: okButtonText},
        {className: 'btn-lg', style: 'secondary', handlerClick: modalCancelHandler, text: cancelButtonText},
      ],
      modalCancelHandler,
    );
  };

  const renderText = () => (
    <span className="header-text">
      <span className="header-text-title">
        {`${picklistDefinition.currentStep}/${totalLabware} ${defaultText} ${picklistDefinition.labwareMap[picklistDefinition.currentStep]?.name.toUpperCase()}`}
      </span>
    </span>
  );

  const onBack = () => {
    taskListPicklistBusinessPicklistOnBack();
  };

  return (
    <div ref={headerRef}>
      <WizardHeader
        hideBackButton={hideBackButton()}
        hideNextButton
        cancelButtonText="CANCEL"
        onBackClick={onBack}
        onCancelClick={onCancel}
      >
        {renderText()}
      </WizardHeader>
    </div>
  );
}

PicklistHeader.propTypes = {
  headerRef: PropTypes.any,
  intl: PropTypes.object.isRequired,
  picklistDefinition: PropTypes.object.isRequired,
  taskListPicklistBusinessCancelPicklist: PropTypes.func.isRequired,
  taskListPicklistBusinessPicklistOnBack: PropTypes.func.isRequired,
  modalStateActionShowModal: PropTypes.func.isRequired,
  modalStateActionHideModal: PropTypes.func.isRequired,
  appStateActionShowSnackbar: PropTypes.func.isRequired,
  cardStateActionSetAllTaskIsSelected: PropTypes.func.isRequired,
  undoRedoBusinessActionGlobalAddUndoItem: PropTypes.func.isRequired,
  setProtocolEditorMode: PropTypes.func.isRequired,
};

PicklistHeader.defaultProps = {
  headerRef: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(PicklistHeader));
